var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 18.1001C3.41667 18.1001 3.125 17.9751 2.875 17.7251C2.625 17.4751 2.5 17.1834 2.5 16.8501V4.3501C2.5 4.01676 2.625 3.7251 2.875 3.4751C3.125 3.2251 3.41667 3.1001 3.75 3.1001H16.25C16.5833 3.1001 16.875 3.2251 17.125 3.4751C17.375 3.7251 17.5 4.01676 17.5 4.3501V16.8501C17.5 17.1834 17.375 17.4751 17.125 17.7251C16.875 17.9751 16.5833 18.1001 16.25 18.1001H3.75ZM3.75 16.8501H16.25V4.3501H3.75V16.8501Z",
    fill: "#818EA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxEmpty);
export default __webpack_public_path__ + "static/media/checkbox-empty.ab37f64aab09c662b02abd7ca607ae28.svg";
export { ForwardRef as ReactComponent };